<template>
    <div class="modal-header">
        <div class="flex items-center gap-2">
            <h3 class="modal-header__title">{{ title }}</h3>
            <slot />
        </div>
        <Button v-if="closeable" type="button" color="default" variant="inline" size="sm" @click="emit('close')">
            <Icon icon="hero/outline/x-mark" class="w-5 h-5" />
        </Button>
    </div>
</template>

<script setup lang="ts">
interface Props {
    title: string;
    closeable?: boolean;
}

withDefaults(defineProps<Props>(), {
    closeable: true,
});

const emit = defineEmits<{
    close: [];
}>();
</script>
